import React, { useEffect, useState } from "react";

//Jds
import { Container, Icon } from "@jds/core";

// Local
import Sidepanel from "./Sidepanel/Sidepanel";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidepanel_new from "./Sidepanel/Sidepanel_new";

export default function EventDetailLayout(props) {
  const [open, setOpen] = useState(true);
  const [mobileView, setMobileView] = useState();
  useEffect(() => {
    console.log(window.innerWidth);
    if (window.innerWidth < 700) {
      setMobileView(true);
      setOpen(false);
    }
  }, []);
  window.addEventListener("resize", function () {
    if (window.innerWidth >= 700) {
      setOpen(true);
      setMobileView(false);
    } else {
      setOpen(false);
      setMobileView(true);
    }
  });
  return (
    <Container direction="row" fullWidth>
      {/* <Sidepanel /> */}
      <div style={{ position: "fixed", zIndex: 49 }}>
        <Sidepanel_new open={open} setOpen={setOpen} mobileView={mobileView} />
      </div>
      <Box
        // p="32px 64px"
        // p="32px 72px"
        p={open ? "32px 295px 0px" : "32px 8px"}
        paddingRight={open ? "30px" : "20px"}
        marginLeft={!open ? "88px" : ""}
        // pr={"128px"}
        // style={{ flex: 1 }}
        // maxWidth={1158}
        mt={"72px"}
        sx={{
          flex: 1,
          width: "100%",
          // width: "680px",
          // maxWidth: "1158px",
          // zIndex: 1,
        }}
      >
        <Outlet />
      </Box>
    </Container>
  );
}
